import { Columns3, X } from "lucide-react";
import { API } from "../lib/apiClient";
import { useCompanyLogos } from "../lib/companies";
import { PdfShareMenu, faviconFor } from "./QuotePdfMenu";

const custKey = (q) => q.customerId || (q.customerName || "").toLocaleLowerCase("tr-TR").trim();

export function QuoteCompareBar({ selected, onClear, onSent }) {
  const logos = useCompanyLogos();
  if (!selected.length) return null;
  const mixed = new Set(selected.map(custKey)).size > 1;
  const tooMany = selected.length > 6;
  const ready = selected.length >= 2 && !mixed && !tooMany;
  const first = selected[0];
  return (
    <div className="compare-bar" data-testid="quote-compare-bar">
      <Columns3 size={16} />
      <span data-testid="quote-compare-count"><b>{selected.length}</b> teklif seçildi</span>
      {mixed && <em className="compare-warn" data-testid="quote-compare-warning">Seçilen teklifler farklı müşterilere ait — aynı müşterinin tekliflerini seçin</em>}
      {!mixed && tooMany && <em className="compare-warn" data-testid="quote-compare-warning">En fazla 6 teklif karşılaştırılabilir</em>}
      {!mixed && selected.length === 1 && <em className="compare-hint">Karşılaştırma için en az 2 teklif seçin</em>}
      <div className="compare-actions">
        {ready && (
          <PdfShareMenu base={`${API}/quotes/compare-pdf`} label="Karşılaştırma PDF" primary testId="compare"
            payload={() => ({ origin: window.location.origin, quoteIds: selected.map((q) => q.id), companyLogos: Object.fromEntries(selected.map((q) => [q.company, faviconFor(q.company, logos)])) })}
            phone={first.customerPhone} email={first.customerEmail}
            waText={(link, data) => `${first.customerName ? `Merhaba ${first.customerName},` : "Merhaba,"} ${selected.length} sigorta şirketinden aldığım teklifleri karşılaştırmalı olarak iletiyorum. Size uygun olanı bu sayfadan tek dokunuşla seçebilirsiniz: ${data?.choicePath ? `${window.location.origin}${data.choicePath}` : link} (bağlantı 7 gün geçerlidir)`}
            onSent={(data) => onSent(selected.map((q) => q.id), data)} />
        )}
        <button type="button" className="ghost-button" onClick={onClear} data-testid="quote-compare-clear"><X size={14} /> Temizle</button>
      </div>
    </div>
  );
}
